import React, {Component} from 'react'
import {Menu} from 'semantic-ui-react'
import UserMenu from './userMenu'
import {S3Image} from "./custom-common";
import IMAGE from "../constants/images";

class MainMenu extends Component {
    render() {
        const {center} = this.props;
        return (
            <React.Fragment>
                <Menu fixed='top' secondary pointing className="member-menuContainer">
                    <div className={'menuLogoColumn'}>
                        <S3Image {...IMAGE.OFFICIAL_LOGO}/>
                    </div>
                    <div className={'menuCenterColumn'}>
                         <b>{center}</b>
                    </div>
                    <UserMenu/>
                </Menu>
                <div className={"member-header-shadow"}/>
            </React.Fragment>
        )
    }
}

export default MainMenu;
